<template lang="pug">
.progressBarComponent
  .bar
    .inner(:style="innerBarStyles")
    .value {{ percentCompleted }}%
</template>

<script>
export default {
  props: {
    percentCompleted: {
      type: Number,
      default: 0
    }
  },
  computed: {
    innerBarStyles () {
      return {
        transform: `translateX(-${85 - 85 / 100 * this.percentCompleted}%)`
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.progressBarComponent
  width: 100%
  display: flex
  align-items: center
  justify-content: center
  position: relative
  margin-bottom: $u

  > .bar
    height: 9*$u
    width: 100%
    background-color: $cElements
    border-radius: 99em
    overflow: hidden
    box-shadow: 0 $u 0 $cDarkBackground

    > .inner
      height: 100%
      width: 100%
      background-color: $cBlue
      border-radius: 99em

    > .value
      @include font('t16-demibold')
      position: absolute
      top: 50%
      left: 0
      transform: translateY(-50%)
      margin-left: 4*$u
      color: $cWhite
</style>
